import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { setCredentials } from "../features/auth/authSlice";
import Url from "../global";
import appVersion from "../utils/appVersion";

const LoginOrtu = () => {
  const GUIDE_VIDEO_FILE_ID = "1bnwEXZbiyf_-GCIpZKGgUVIxoAyUrd9H";
  const WEB_PDF_URL =
    "https://drive.google.com/file/d/1eqXEyV6TxTbJkYpglTZMVvYUHpaKgBSb/view?usp=drive_link";
  const GUIDE_VIDEO_URL = `https://drive.google.com/file/d/${GUIDE_VIDEO_FILE_ID}/view`;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${Url}/wali`,
        {
          strUserName: username,
          strPassword: password,
        },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        },
      );

      const accessToken = response.data.accessToken;

      dispatch(setCredentials({ accessToken, user: response.data.user }));

      toast.success("Login Berhasil!");
      navigate("/dashboard-ortu");
    } catch (error) {
      if (!error.response) {
        setLoginError("Tidak ada respon dari server");
        return;
      }

      const serverMessage =
        error.response?.data?.msg ||
        error.response?.data?.message ||
        "Pengguna tidak dikenal dan/atau password tidak sesuai.";

      setLoginError(serverMessage);
    }
  };

  const handleRetry = () => {
    setUsername("");
    setPassword("");
    setLoginError("");
  };

  const inputStyle = {
    width: "100%",
    padding: "14px 16px",
    border: "1px solid #c8d6db",
    borderRadius: "14px",
    boxSizing: "border-box",
    backgroundColor: "#f8fbfc",
    color: "#17313a",
    fontSize: "15px",
    outline: "none",
  };

  const guideLinkStyle = {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    width: "100%",
    padding: "14px 16px",
    borderRadius: "16px",
    textDecoration: "none",
    background: "linear-gradient(180deg, #f8fbfc 0%, #eef5f7 100%)",
    border: "1px solid #d7e4e8",
    boxSizing: "border-box",
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: "24px",
        background:
          "radial-gradient(circle at top left, rgba(246, 225, 170, 0.45), transparent 28%), radial-gradient(circle at bottom right, rgba(25, 97, 110, 0.18), transparent 30%), linear-gradient(135deg, #c1d5da 0%, #9fbcc3 46%, #86aeb6 100%)",
        margin: 0,
        fontFamily: "'Trebuchet MS', 'Verdana', sans-serif",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "-90px",
          left: "-40px",
          width: "260px",
          height: "260px",
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.22)",
          filter: "blur(10px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          right: "-80px",
          bottom: "-120px",
          width: "320px",
          height: "320px",
          borderRadius: "50%",
          background: "rgba(12, 67, 79, 0.16)",
          filter: "blur(20px)",
        }}
      />
      <div
        style={{
          background: "rgba(255, 255, 255, 0.94)",
          borderRadius: "28px",
          padding: "18px",
          width: "100%",
          maxWidth: "520px",
          boxShadow: "0 24px 60px rgba(26, 57, 66, 0.20)",
          border: "1px solid rgba(255, 255, 255, 0.6)",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          style={{
            background: "linear-gradient(180deg, #ffffff 0%, #f7fbfc 100%)",
            borderRadius: "22px",
            padding: "32px 22px 22px",
            border: "1px solid #e4eef1",
          }}
        >
          
          <h2
            style={{
              textAlign: "center",
              margin: "0 0 40px",
              fontWeight: "700",
              fontFamily: "Georgia, 'Times New Roman', serif",
              fontSize: "42px",
              color: "#10242b",
              letterSpacing: "0.02em",
            }}
          >
            WALI MURID
          </h2>
         
        {loginError ? (
          <div
            style={{
              textAlign: "center",
              padding: "22px 18px",
              background: "linear-gradient(180deg, #fff5f4 0%, #fffafb 100%)",
              border: "1px solid #f4d0cb",
              borderRadius: "18px",
            }}
          >
            <p
              style={{
                color: "#d32f2f",
                fontSize: "16px",
                marginBottom: "20px",
                fontWeight: "600",
                lineHeight: "1.5",
              }}
            >
              {loginError}
            </p>
            <button
              onClick={handleRetry}
              style={{
                width: "100%",
                padding: "14px",
                background: "linear-gradient(135deg, #f06055 0%, #d83b2d 100%)",
                color: "white",
                border: "none",
                borderRadius: "14px",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Coba Lagi
            </button>
          </div>
        ) : (
          <form onSubmit={handleLogin} style={{ marginTop: "18px" }}>
            <div style={{ marginBottom: "18px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  color: "#34545d",
                  fontSize: "13px",
                  fontWeight: "700",
                  letterSpacing: "0.03em",
                  textTransform: "uppercase",
                }}
              >
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Masukkan username"
                autoComplete="username"
                style={inputStyle}
              />
            </div>
            <div style={{ marginBottom: "22px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  color: "#34545d",
                  fontSize: "13px",
                  fontWeight: "700",
                  letterSpacing: "0.03em",
                  textTransform: "uppercase",
                }}
              >
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Masukkan password"
                autoComplete="current-password"
                style={inputStyle}
              />
            </div>

            <button
              type="submit"
              style={{
                width: "100%",
                padding: "15px",
                background: "linear-gradient(135deg, #5f94f7 0%, #3d73d9 100%)",
                color: "white",
                border: "none",
                borderRadius: "16px",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "700",
                marginBottom: "20px",
                boxShadow: "0 14px 24px rgba(71, 112, 208, 0.24)",
              }}
            >
              Login
            </button>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "16px",
                padding: "16px",
                borderRadius: "18px",
                background: "linear-gradient(180deg, #fbfdfe 0%, #f2f7f9 100%)",
                border: "1px solid #dde9ed",
              }}
            >
              <div
                style={{
                  color: "#274c57",
                  fontSize: "12px",
                  fontWeight: "700",
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                }}
              >
                Panduan Akses
              </div>
              <a
                href={WEB_PDF_URL}
                target="_blank"
                rel="noreferrer"
                style={guideLinkStyle}
              >
                <span
                  style={{
                    minWidth: "48px",
                    padding: "8px 0",
                    borderRadius: "12px",
                    backgroundColor: "#ddeaf2",
                    color: "#295a74",
                    textAlign: "center",
                    fontSize: "12px",
                    fontWeight: "700",
                    letterSpacing: "0.08em",
                  }}
                >
                  PDF
                </span>
                <span style={{ display: "flex", flexDirection: "column" }}>
                  <span
                    style={{
                      color: "#16343d",
                      fontSize: "14px",
                      fontWeight: "700",
                      marginBottom: "2px",
                    }}
                  >
                    Lihat Panduan PDF
                  </span>
                  <span style={{ color: "#5d747c", fontSize: "12px" }}>
                    Buka file panduan penggunaan portal.
                  </span>
                </span>
              </a>
              <a
                href={GUIDE_VIDEO_URL}
                target="_blank"
                rel="noreferrer"
                style={guideLinkStyle}
              >
                <span
                  style={{
                    minWidth: "48px",
                    padding: "8px 0",
                    borderRadius: "12px",
                    backgroundColor: "#e8efe0",
                    color: "#50713f",
                    textAlign: "center",
                    fontSize: "12px",
                    fontWeight: "700",
                    letterSpacing: "0.08em",
                  }}
                >
                  PLAY
                </span>
                <span style={{ display: "flex", flexDirection: "column" }}>
                  <span
                    style={{
                      color: "#16343d",
                      fontSize: "14px",
                      fontWeight: "700",
                      marginBottom: "2px",
                    }}
                  >
                    Lihat Panduan Video
                  </span>
                  <span style={{ color: "#5d747c", fontSize: "12px" }}>
                    Tonton langkah penggunaan secara visual.
                  </span>
                </span>
              </a>
            </div>
          </form>
        )}

        <div
          style={{
            textAlign: "left",
            fontSize: "12px",
            color: "#566f77",
            paddingTop: "4px",
          }}
        >
          Lupa Password? Hubungi Tata Usaha
        </div>
        <div
          style={{
            textAlign: "center",
            fontSize: "12px",
            color: "#6b8188",
            paddingTop: "10px",
          }}
        >
          Versi aplikasi v{appVersion}
        </div>
        </div>
      </div>
    </div>
  );
};

export default LoginOrtu;
